<div class="flex-1 flex flex-col gap-1">
  <span class="text-base text-slate-900 font-semibold">
    {{ item.title }}
  </span>

  <div class="h-px bg-slate-100"></div>

  <div>
    <div #container></div>
  </div>
</div>
